<template>
  <b-navbar toggleable="md" type="light" variant="light">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand href="#"><img src="./../assets/logo.png" class="logo"/> Next Datamanager</b-navbar-brand>
    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav v-if="signedIn">
        <b-nav-item :to="'/calendar'">Calendar</b-nav-item>
        <b-nav-item :to="'/teams'">Teams</b-nav-item>
        <!-- <b-nav-item href="#" disabled>Disabled</b-nav-item> -->
      </b-navbar-nav>
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto" v-if="signedIn">
        <b-nav-item :to="'/sign-in'" right>Sign out</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
export default {
  name: 'Navbar',
  data () {
    return {}
  },
  computed: {
    signedIn () {
      return this.$store.state.authentication.status.signedIn
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
img.logo{
  height: 35px;
  margin-right: 10px;
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue